export default {
  heading: 'Din, serif',
  body: 'Open Sans, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Finger Paint, cursive',
  googleFonts: ['Open Sans:100,200,300,400,500,600,700,800,900', 'Finger Paint'],
  customFamilies: ['Din'],
  customUrls: ['https://www.gonation.biz/fonts/din/din.css']
}
